<script setup lang="ts">
import { computed } from 'vue';
import InputNumber, { type InputNumberInputEvent } from 'primevue/inputnumber';
import { MAX_BID_AMOUNT_CENTS } from '@neon-one/auctions-types';

import { useBidStore } from '../store';

const store = useBidStore();
const maxDollars = MAX_BID_AMOUNT_CENTS / 100;

const dollars = computed({
  get: () => store.amountCents / 100,
  set: (next: number | null) => store.setAmount(next == null ? 0 : Math.max(0, Math.round(next * 100))),
});

function onInput(e: InputNumberInputEvent): void {
  const v = typeof e.value === 'number' ? e.value : null;
  store.setAmount(v == null ? 0 : Math.max(0, Math.round(v * 100)));
}
</script>

<template>
  <div class="app-field-group">
    <label
      for="bid-amount"
      class="app-field-label"
    >{{ store.isMaxBid ? 'Maximum bid' : 'Bid amount' }}</label>
    <InputNumber
      v-model="dollars"
      input-id="bid-amount"
      mode="currency"
      currency="USD"
      locale="en-US"
      :min="0"
      :max="maxDollars"
      :max-fraction-digits="2"
      :min-fraction-digits="0"
      highlight-on-focus
      data-testid="bid-amount-input"
      @input="onInput"
    />
    <small
      v-if="store.errorMinimumCents !== null"
      class="app-field-helper"
    >
      Next minimum: {{ (store.errorMinimumCents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}
    </small>
    <small
      v-if="store.amountExceedsMax"
      class="app-field-error"
      data-testid="bid-amount-input__max-error"
    >
      Bids cannot exceed {{ maxDollars.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}.
    </small>
  </div>
</template>

<style scoped>
.app-field-group {
  display: flex;
  flex-direction: column;
  gap: var(--app-space-4);
}
</style>
